export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/reminders-hearts-bg-33794a240c3d96f529bda1a6aefa6819.jpg";